import { css } from "@emotion/react"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { ImageViewerOverlay, useImageViewerOverlay } from "./ImageViewerOverlay"
import { useOperationAttachmentImage } from "@/hooks/useOperationAttachmentImage"

interface OperationAttachmentImagesProps {
    operationId: string
}

export const OperationAttachmentImages = ({
    operationId
}: OperationAttachmentImagesProps) => {
    const { token } = useAuth()
    const { data } = useOperationAttachmentImage(token, operationId)

    const images = data?.images ?? []

    const { openedImage, openImageViewer, closeImageViewer } =
        useImageViewerOverlay()

    return (
        <>
            <ImageViewerOverlay
                openedImage={openedImage}
                onClose={closeImageViewer}
            />
            <div
                css={css`
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 4px;
                    margin-top: 8px;
                `}
            >
                {images.map(image => {
                    return (
                        <img
                            key={image.id}
                            src={image.imageUrl}
                            css={css`
                                width: 100%;
                                aspect-ratio: 1 / 1;
                                object-fit: cover;
                            `}
                            loading="lazy"
                            alt=""
                            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                            role="button"
                            onClick={() => {
                                openImageViewer(image)
                            }}
                        />
                    )
                })}
            </div>
        </>
    )
}
